import React from 'react';
import ReactDOM from 'react-dom';
import Dialog from './dialog';

const createConfirm = (props) => {
	const $wrapper = document.body.appendChild(document.createElement('div'));

	const attach = () => {
		return new Promise((resolve, reject) => {
			ReactDOM.render(
				<Dialog resolve={resolve} reject={reject}  {...props}/>, $wrapper
			);
		});
	};

	const detach = () => {
		ReactDOM.unmountComponentAtNode($wrapper);
		$wrapper.remove();
	};

	const resolve = () => { detach(); return true; };
	const reject = () => { detach(); return false; };

	return attach().then(resolve, reject);
};

export default createConfirm;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/confirm/createConfirm.js